import styled from 'styled-components';
import { Button } from '@bynder/design-system';

export const DropDownButton = styled(Button)`
    justify-content: flex-start;
    text-transform: capitalize;

    & div:last-child {
        margin-left: auto;
    }
`;
